import StyleSheet from "./StyleSheet";

export default StyleSheet;
